// Product catalog + add-on API fns — carved verbatim from `src/api/scribeAPIV2.ts`
// (which now re-exports from here). Transport comes from the `@heidi/api`
// configured-client registry (E5, ARCFE-805) — the registry hands back the
// app's real `scribeHttpV2` singleton (same interceptors, same retry/refresh
// state), so behaviour is byte-identical. `CommerceHttpClient` keeps the
// public signatures structural (no axios types in this package's surface).
//
// DOMAIN RULING (D1, ARCFE-972): both were `@domain REVIEW`. Each serves
// exactly one commerce-claimed hook (`useQueryProducts`,
// `useQueryAddOnProduct`) on a commerce route (`/products*`), so they are
// ruled `@domain commerce` at carve — the dictation P0.4-class precedent.

import { getScribeHttpClients } from '@heidi/api/client';
import {
  type GetAddOnProductsParams,
  type GetAddOnProductsResponse,
  type GetHeidi2ProductsResponse,
  type ProductView,
  type SubscriptionTier,
} from '../../contracts';
import { type CommerceHttpClient } from '../config';

const http = (): CommerceHttpClient => getScribeHttpClients().scribeHttpV2;
const PRODUCTS_REQUEST_TIMEOUT_MS = 15_000;

/** @domain commerce */
export const getProducts = (params?: {
  new_product_tiers?: SubscriptionTier[] | null;
}) => {
  return http().get<{ products: ProductView[] }>(`/products`, {
    params,
  });
};

/** @domain commerce — v3 rows state `seat_type`; v2's `ProductView` does not. */
export const getHeidi2Products = () => {
  const clients = getScribeHttpClients();
  return clients.scribeHttpV2.get<GetHeidi2ProductsResponse>(
    `${clients.getScribeBaseUrlFromV2()}/api/v3/ml-scribe/products`,
    { timeout: PRODUCTS_REQUEST_TIMEOUT_MS }
  );
};

/** @domain commerce */
export const getAddOnProducts = (params?: GetAddOnProductsParams) => {
  return http().get<GetAddOnProductsResponse>(`/products/add-on-products`, {
    params,
  });
};
